module.exports = __webpack_public_path__ + "img/ConfigurationIcon.543bf9cb.png";